export default "__VITE_ASSET__519c1baa__"